import {css} from 'lit'; export default css`sds-system-notification [slot=content] a{color:#2c79e7;text-decoration:none}sds-system-notification [slot=content] a:hover{text-decoration:underline}`;
    